import { render, staticRenderFns } from "./CaseImage.vue?vue&type=template&id=222d3427&scoped=true&"
import script from "./CaseImage.vue?vue&type=script&lang=ts&setup=true&"
export * from "./CaseImage.vue?vue&type=script&lang=ts&setup=true&"
import style0 from "./CaseImage.vue?vue&type=style&index=0&id=222d3427&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "222d3427",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/prodoctorov/pd-ssr/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('222d3427')) {
      api.createRecord('222d3427', component.options)
    } else {
      api.reload('222d3427', component.options)
    }
    module.hot.accept("./CaseImage.vue?vue&type=template&id=222d3427&scoped=true&", function () {
      api.rerender('222d3427', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "www/vue_components/common/DoctorCases/components/CaseImage.vue"
export default component.exports